export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/gorji/HomeView.vue'),
  },
  {
    meta: { title: 'menu.codes' },
    path: '/codes',
    name: 'codes',
    component: () => import('@/views/gorji/CodesView.vue'),
  },
  {
    // path the backend sidebar menu (/admin/menu) points the codes-create entry at
    meta: { title: 'menu.codes' },
    path: '/add-codes',
    name: 'add-codes',
    component: () => import('@/views/gorji/CodesView.vue'),
  },
]
